import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../firebase/firebaseConfig";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { useAuth } from "../contextos/AuthContext";

const ActivarMembresia = () => {
  const { token } = useParams();
  const { usuario } = useAuth();

  const [estado, setEstado] = useState("cargando");

  useEffect(() => {

    const validar = async () => {
  
      if (!usuario) return;
  
      const ref = doc(
        db,
        "membresias",
        token
      );
  
      const snap =
        await getDoc(ref);
  
      if (!snap.exists()) {
  
        setEstado("no_existe");
        return;
      }
  
      const data = snap.data();
  
      if (data.asignada) {
  
        setEstado("ya_usada");
        return;
      }
  
      setEstado("confirmar");
    };
  
    validar();
  
  }, [usuario, token]);

  const activarMembresia =
	async () => {

		try {

			const ref = doc(
				db,
				"membresias",
				token
			);

			const ahora = new Date();

			const fin = new Date();

			fin.setMonth(
				fin.getMonth() + 1
			);

			await updateDoc(ref, {

				estudianteId:
					usuario.uid,

				asignada: true,

				fechaInicio: ahora,

				fechaFin: fin
			});

			setEstado("activada");

		} catch (error) {

			console.error(error);

			setEstado("error");
		}
	};  

  return (

    <div
      style={{
        padding: "40px",
        color: "white"
      }}
    >
  
      {estado === "cargando" && (
        <p>
          Validando membresía...
        </p>
      )}
  
      {estado === "no_existe" && (
        <p>
          ❌ Membresía no encontrada
        </p>
      )}
  
      {estado === "ya_usada" && (
        <p>
          ⚠️ Esta membresía ya fue usada
        </p>
      )}
  
      {estado === "confirmar" && (
  
        <div>
  
          <h2>
            🔥 Activar membresía
          </h2>
  
          <p>
            Vas a activar esta
            membresía con:
          </p>
  
          <p>
            <strong>
              {usuario?.email}
            </strong>
          </p>
  
          <button
            onClick={
              activarMembresia
            }
          >
            Activar ahora
          </button>
  
        </div>
      )}
  
      {estado === "activada" && (
        <p>
          ✅ Membresía activada
          correctamente
        </p>
      )}
  
      {estado === "error" && (
        <p>
          ❌ Error activando
          membresía
        </p>
      )}
  
    </div>
  );
};
export default ActivarMembresia;